module.exports = __webpack_public_path__ + "img/footer.05fb12a6.png";